import React, { useState, useEffect } from "react";
import Container from "../common/Container";
import Row from "../common/Row";
import ProductCard from "../common/ProductCard";
import axios from "axios";

const BestSellerProducts = () => {
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null); // Selected category

  const getData = async () => {
    try {
      const response = await axios.get(
        "https://fakestoreapi.com/products?limit=10"
      );
      setProducts(response.data); // Store products
    } catch (error) {
      console.error("ERROR", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category); // Update selected category
  };

  // Filter products based on the selected category
  const filteredProducts =
    selectedCategory === null
      ? products
      : products.filter((product) => product.category === selectedCategory);

  return (
    <Container>
      <div id="products" className="pt-16"><p className="text-sm font-semibold uppercase tracking-widest text-indigo-600">The catalogue</p><h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">Best sellers</h2></div>

      <Row className="mt-8 flex-wrap gap-2">
        {/* "All Products" Button */}
        <p
          className={`rounded-full px-4 py-2 text-sm font-semibold transition ${selectedCategory === null ? 'bg-slate-900 text-white' : 'bg-white text-slate-600 hover:bg-slate-100'}`}
          onClick={() => handleCategoryClick(null)}
        >
          All Products
        </p>
        {/* Categories */}
        {[...new Set(products.map((item) => item.category))].map(
          (category, index) => (
            <p
              key={index}
              className={`rounded-full px-4 py-2 text-sm font-semibold capitalize transition ${selectedCategory === category ? 'bg-slate-900 text-white' : 'bg-white text-slate-600 hover:bg-slate-100'}`}
              onClick={() => handleCategoryClick(category)} // Filter by category
            >
              {category}
            </p>
          )
        )}
      </Row>

      {/* Product Grid */}
      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {filteredProducts.map((item) => (
          <div key={item.id}>
            <ProductCard data={item} />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default BestSellerProducts;
